export const getTimelineAssetById = (state: RootState,
  id: string) => state.layer.assets.find(asset => asset.id === id)
